import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { StickerCard as UIStickerCArd, Typography } from "@parkschannel/ui";
import { ImgixImage } from "../../ImgixImage";
const ONE_DAY = 7 * 24 * 60 * 60 * 1000;
export const StickerCard = (param)=>{
    let { renderImage , onClick , ...rest } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative cursor-pointer",
        tabIndex: 0,
        onClick: ()=>{
            return onClick === null || onClick === void 0 ? void 0 : onClick(rest.data);
        },
        children: [
            /*#__PURE__*/ _jsx(UIStickerCArd, {
                ...rest,
                renderImage: renderImage || ((imgKey, name)=>/*#__PURE__*/ _jsx(ImgixImage, {
                        src: imgKey,
                        alt: name,
                        fill: true,
                        className: "object-contain"
                    }))
            }),
            rest.data.stickerDate ? findTimeElapsed(new Date(rest.data.stickerDate)) < ONE_DAY ? /*#__PURE__*/ _jsx(NewLabel, {}) : null : null
        ]
    });
};
function NewLabel() {
    return /*#__PURE__*/ _jsx("div", {
        className: "px-2 py-1 rounded-2xl bg-yellow1 absolute top-4 right-4",
        children: /*#__PURE__*/ _jsx(Typography, {
            variant: "bodySmall",
            className: "text-neutral-700",
            children: "New"
        })
    });
}
function findTimeElapsed(start) {
    const now = Date.now();
    return now - start.getTime();
}
